/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_EyebrowInputs */

const en_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welcome to Glider.`)
};

const de_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Willkommen bei Glider.`)
};

const pt_br2_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Boas-vindas à Glider.`)
};

const tr_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider'a hoş geldiniz.`)
};

const zh_cn2_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欢迎使用 Glider。`)
};

const zh_hk2_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`歡迎使用 Glider。`)
};

const ko_kr2_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Glider에 오신 것을 환영합니다.`)
};

const ru_ru2_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добро пожаловать в Glider.`)
};

const es_419_onboarding_v1_username_eyebrow = /** @type {(inputs: Onboarding_V1_Username_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Te damos la bienvenida a Glider.`)
};

/**
* | output |
* | --- |
* | "Welcome to Glider." |
*
* @param {Onboarding_V1_Username_EyebrowInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_eyebrow = /** @type {((inputs?: Onboarding_V1_Username_EyebrowInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_EyebrowInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_eyebrow(inputs)
	if (locale === "de") return de_onboarding_v1_username_eyebrow(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_eyebrow(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_eyebrow(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_eyebrow(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_eyebrow(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_eyebrow(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_eyebrow(inputs)
	return es_419_onboarding_v1_username_eyebrow(inputs)
});